
import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import ProfileCard from "@/components/ProfileCard";
import { toast } from "sonner";

export default function Shortlist() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            const { data } = await client.get("/shortlist");
            setItems(data);
        } catch { toast.error("Failed to load"); }
        finally { setLoading(false); }
    };

    useEffect(() => { load(); }, []);

    const interest = async (p) => {
        try { await client.post(`/interests/${p.user_id}`); toast.success("Interest sent"); }
        catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    };

    return (
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-12">
            <div className="text-[11px] tracking-[0.25em] uppercase text-gold-700 font-semibold">Saved Profiles</div>
            <h1 className="mt-2 font-serif text-5xl text-navy tracking-tighter">Your shortlist</h1>
            <p className="mt-2 text-navy-500 font-sans">Profiles you&rsquo;ve cherished and saved for prayerful consideration.</p>

            {loading ? <div className="mt-10 text-navy-400">Loading…</div> : items.length === 0 ? (
                <div className="mt-10 bg-linen rounded-2xl p-16 text-center">
                    <h3 className="font-serif text-3xl text-navy">No saved profiles yet</h3>
                    <p className="mt-2 text-navy-500 font-sans">Tap the heart on any profile to save it here.</p>
                </div>
            ) : (
                <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {items.map((p) => <ProfileCard key={p.user_id} profile={p} onInterest={interest} />)}
                </div>
            )}
        </div>
    );
}
